import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['option', 'emailContainer', 'email']
  
  show(event) {
    if (this.hasEmailContainerTarget) {
      if (event.target.dataset.primaryEmail.length > 0) {
        this.emailContainerTarget.classList.remove('hide')
        this.emailTarget.innerHTML = event.target.dataset.primaryEmail
      } else {
        this.hide()
      }
    }
  }
  
  hideWhenEmpty(event) {
    if (event.target.value == '' && this.hasEmailContainerTarget) {
      this.hide()
    }
  }
  
  hide() {
    this.emailContainerTarget.classList.add('hide')
    this.emailTarget.innerHTML = ''
  }

}